// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__M6_Jm","header__img":"styles_header__img__x0KtF","header__body":"styles_header__body__35u8J","back":"styles_back__mwAuW"};